import React, {useContext, useState} from "react";
import { makeStyles } from "@material-ui/core/styles";
import { Theme } from "@material-ui/core";
import Grid from "@material-ui/core/Grid";
import TextField from "@material-ui/core/TextField";
import Toolbar from "@material-ui/core/Toolbar";
import Typography from "@material-ui/core/Typography";
import PersonPin from "@material-ui/icons/PersonPin";
import * as Dati from "../../../Dati";
import { Trad } from "../../../components";
import {AlertDialogContext} from "../../providers/AlertDialogProvider";
import {_ButtonAPI} from "../common/ButtonAPI";
import * as Glob from "../../../Globale";

interface IChangeOwnersProps {
    IdAnag: number;
    OnChange: (val: string) => void;
}

const useStyles = makeStyles(({ shape, spacing, palette }: Theme) => ({
    icon: {
        marginRight: spacing(2)
    },
    title: {
        flexGrow: 1,
    },
    toolbar: {
        background: palette.warning.light,
        borderRadius: shape.borderRadius,
        color: palette.success.contrastText,
        marginTop: spacing(4),
        marginBottom: spacing(2)
    },
    removeBtn: {
        color: palette.error.main,
        background: "none"
    },
    divider: {
        marginTop: spacing(3),
        marginBottom: spacing(3)
    }
}));

export const _ChangeOwners: React.FC<IChangeOwnersProps> = ({ IdAnag, OnChange }) => {
    const classes = useStyles();
    const { ShowDialog } = useContext(AlertDialogContext);
    const [fromProp, setFromProp] = useState("");
    const [toProp, setToProp] = useState("");

    const OnClickChangeOwners = (data: Dati.CRisAPI) => {
        if (data.Errore) {
            ShowDialog("ERRORE", Trad.Trad(data.ErrTesto), "error");
        } else {
            ShowDialog("Proprietario cambiato", Trad.Trad("Il proprietario è stato cambiato"), "success");
        }
    };

    const OnError = (error: Error) => {
        ShowDialog("ERRORE", Trad.Trad(error.message), "error");
    };

    const ParametrsChangeOwner: { [Param: string]: any } = [];
    ParametrsChangeOwner["idAnag"] = IdAnag;
    ParametrsChangeOwner["idAnagFrom"] = fromProp;
    ParametrsChangeOwner["idAnagTo"] = toProp;

    return (
        <>
            <Toolbar variant="dense" className={classes.toolbar}>
                <PersonPin className={classes.icon} />
                <Typography variant="subtitle1" color="inherit" className={classes.title}>
                    {Trad.Trad("Proprietari")}
                </Typography>
            </Toolbar>
            <Grid item container xs={12} md={11} spacing={4}>
                <Grid item xs={8} md={2}>
                    <TextField
                        value={fromProp}
                        id="Valore"
                        label={Trad.Trad("Da")}
                        onChange={e => setFromProp(e.currentTarget.value)}
                        fullWidth
                    />
                </Grid>
                <Grid item xs={8} md={2}>
                    <TextField
                        value={toProp}
                        id="Valore"
                        label={Trad.Trad("A")}
                        onChange={e => setToProp(e.currentTarget.value)}
                        fullWidth
                    />
                </Grid>
                <Grid item xs={8} md={2}>
                    <_ButtonAPI
                        Default
                        URL={`/api/Proprietari/UpdateAnagProps`}
                        Metodo="POST"
                        Testo={Trad.Trad("Cambia")}
                        ParamURLLista={ParametrsChangeOwner}
                        OnClick={OnClickChangeOwners}
                        OnErrore={OnError}
                    />
                </Grid>
            </Grid>
        </>
    );
};



// WEBPACK FOOTER //
// ./src/inar2/components/ClientDetails/ChangeOwners.tsx